import { useState } from "react";
import UserService from "../service/api/user";
import {useSnackbar} from "notistack";


export const useUser = () => {
    const {enqueueSnackbar} = useSnackbar();

    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingUser, setLoadingUser] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [userFilter, setUserFilter] = useState(null);
    const [filterUserList, setFilterUserList] = useState([]);
    const [pagination, setPagination] = useState(0)

    const [isFetchingAllUsersForDropdown, setFetchingAllUsersForDropdown] = useState(false);
    const [userListForDropdown, setUserListForDropdown] = useState([]);
    const [isCreatingUser, setIsCreatingUser] = useState(false);

    const limit = 10;

    const listUser = (orgUID, page, searchFor, searchVal) =>{
        setLoading(true)
        UserService.listUser(orgUID, page, searchFor, searchVal, limit).then((res)=>{
            console.log('user list xxxxxxxxxxxxx', res)
            setUserList(res.data.data)
            setLoading(false)

            if(res.data.data.length === 0){
                setPagination(0)
            }else{
            var last_page = Math.ceil(res.data.data.length / limit); 
            console.log('last_page', last_page)
            setPagination(last_page)
            }
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
        })
    }

    const createUser = (parameters) =>{
        setLoading(true)
        setIsCreatingUser(true)
        UserService.createUser(parameters).then((res)=>{
            console.log('createUser xxxxxxxxxxxxx', res)
            setLoading(false)
            setIsCreatingUser(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
            setIsCreatingUser(false)
        })
    }

    const listUserWithNoOrg = () => {
        setLoadingUser(true)
        UserService.listUserWithNoOrg().then((res)=>{
            console.log('listUserWithNoOrg xxxxxxxxxxxxx', res)
            setUserList(res.data.data)
            setFilterUserList(res.data.data.flatMap(item => item.user_info))
            setLoadingUser(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoadingUser(false)
        })
    }

    const viewUser = (parameters) => {
        setLoadingUser(true)
        UserService.viewUser(parameters).then((res)=>{
            console.log('viewUser xxxxxxxxxxxxx', res)
            setUserDetails(res.data.data)
            setLoadingUser(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoadingUser(false)
        })
    }

    const listUserFilter = (parameters) => {
        setLoadingUser(true)
        UserService.listUserFilter(parameters).then((res)=>{
            console.log('viewUser xxxxxxxxxxxxx', res)
            setUserFilter(res.data.data)
            setLoadingUser(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoadingUser(false)
        })
    }

    const listAllUsersForDropdown = (parameters) => {
        setFetchingAllUsersForDropdown(true);   
    
        UserService.listAllUsersForDropdown(parameters).then((res) => {
            console.log("listAllUsersForDropdown data xxxx", res);
    
            if (res.data.success) {
                setFetchingAllUsersForDropdown(false);
                setUserListForDropdown(res.data.data);
            } 
    
        }).catch((error) => {
            console.error("Error fetching all users for dropdown:", error);
            const errorMessage = error?.response?.data?.error || error.message;
    
            setUserListForDropdown([]);
            setFetchingAllUsersForDropdown(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }
    

    return{
        listUser, userList, pagination, loading, 
        
        createUser, listUserWithNoOrg, loadingUser, viewUser, userDetails, listUserFilter, userFilter, filterUserList, isCreatingUser,

        listAllUsersForDropdown,
        isFetchingAllUsersForDropdown,
        userListForDropdown
    }
}